/* eslint-disable  */
/* eslint-disable react/prop-types */
/* eslint-disable import/no-unresolved */
/* eslint-disable global-require */
/* eslint-disable  */
//@ts-nocheck
import React, { useEffect, useRef, useState } from 'react';
import {
  Grid,
  Container,
  Popover,
  Box,
  Paper,
  Typography,
  Button,
  IconButton,
  List,
  ListItem,
  Divider,
  Link,
} from '@mui/material';
import './EditTile.styles.css';
import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import { useLocation, useNavigate } from 'react-router-dom';
import ReactCrop, { Crop, PixelCrop } from 'react-image-crop';
import { imgPreview } from '../../../../services/image-crop/imagePreview';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { setCustomTile, setSelectedTile } from '../../../../store/tile.slice';
import { centerAspectCrop } from '../../../../utils';
import ExitWithoutSavingModal from '../../../User/ExitWithoutSaving/ExitWithoutSavingModal.screen';

const EditTile = () => {
  // Start Account Setting Code
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const imgRef = useRef<HTMLImageElement>(null);
  const [completedCrop, setCompletedCrop] = useState<PixelCrop>();
  const [imagePreviewSrc, setImagePreviewSrc] = useState('');
  const [crop, setCrop] = useState<Crop>();

  function onImageLoad(e: React.SyntheticEvent<HTMLImageElement>) {
    const { width, height } = e.currentTarget;
    setCrop(centerAspectCrop(width, height, 1, width - width * 0.1));
  }
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { customTile } = useAppSelector((state) => state.tile);
  const { state } = useLocation();

  const [openExistModal, setOpenExistModal] = useState(false);
  const handleCloseExistModal = () => {
    setOpenExistModal(false);
  };

  const handleExist = () => {
    navigate('../visualizer/select-tile');
    setOpenExistModal(false);
  };

  const handleBack = () => {
    setOpenExistModal(true);
  };

  const opensecond = Boolean(anchorEl);
  const id = opensecond ? 'simple-popover' : undefined;

  useEffect(() => {
    const imagePreviewFn = async () => {
      if (completedCrop?.width && completedCrop?.height && imgRef.current) {
        const cropImage = await imgPreview(imgRef.current, completedCrop, 1, 0, true);
        setImagePreviewSrc(cropImage);
      }
    };
    imagePreviewFn();
  }, [completedCrop]);

  const rr = useRef(null);

  const img = (state && state.captureImage) || customTile;

  // End Account Setting Code
  return (
    <Grid container direction="row">
      <Grid size={12}>
        <Grid container direction="row" columnSpacing={4} className="GridRow LightSkyBlue">
          <Grid size={12}>
            <Box className="CropPhotoHeader" sx={{ mb: 3 }}>
              <Button className="CommonGrayButton" variant="outlined" onClick={handleBack}>
                Change Tile
              </Button>
              <Button className="CommonLinkButton" variant="outlined">
                Edit Image
              </Button>
              <Button
                variant="contained"
                color="primary"
                className="UsePhotoButton"
                onClick={() => {
                  if (imagePreviewSrc) {
                    dispatch(setCustomTile(null));
                    dispatch(setSelectedTile(imagePreviewSrc));
                    navigate('../visualizer/configure-tile');
                  }
                }}
              >
                Use Photo
              </Button>
            </Box>
          </Grid>
          <Grid size={12}>
            <Box className="CropPhotoCanvas">
              {!customTile ? (
                <p>Please select tile</p>
              ) : (
                <ReactCrop
                  ref={rr}
                  aspect={1 / 1}
                  minHeight={50}
                  minWidth={50}
                  crop={crop}
                  keepSelection
                  onChange={(c) => setCrop(c)}
                  onComplete={(img: PixelCrop) => {
                    setCompletedCrop(img);
                  }}
                >
                  {img && (
                    <img
                      style={{ width: 400, height: 'auto' }}
                      ref={imgRef}
                      src={img}
                      alt=""
                      onLoad={onImageLoad}
                    />
                  )}
                </ReactCrop>
              )}
            </Box>
            {/* <img src={imagePreviewSrc} alt="" /> */}
          </Grid>
        </Grid>
        <Grid container direction="row" columnSpacing={1} className="GridRow PaddingBottom0">
          <Grid size={12}>
            <Container maxWidth="sm" disableGutters>
              <Grid container direction="row" columnSpacing={0} className="DefaultTileContainer">
                <Grid size={12}>
                  <Box className="PhotoInfo MargingBottom0">
                    <Typography variant="h5">
                      <b>For Best Outcomes</b>
                    </Typography>
                    <List className="CustomList">
                      <ListItem>Ensure the tile is properly lit in the photo</ListItem>
                      <ListItem>Crop out anything you don’t want on the tile</ListItem>
                    </List>
                  </Box>
                </Grid>
              </Grid>
            </Container>
          </Grid>
        </Grid>
      </Grid>
      <ExitWithoutSavingModal
        open={openExistModal}
        handleClose={handleCloseExistModal}
        onExist={handleExist}
      />
    </Grid>
  );
};

export default EditTile;
